// extracted by mini-css-extract-plugin
export default {"iframe":"styles_iframe__0p4yp","title":"styles_title__friL3","nextPageBtn":"styles_nextPageBtn__Of6Hu"};